function headerMenu() {
  return {
    isOpen: false,
    show: false,
    menu: null,
    activeButton: null,
    openIndex: null,

    mouseEnter(index) {
      this.menu = index;
      this.activeButton = index;
      this.isOpen = true;
      this.$dispatch("overlay-toggle", true);
    },
    mouseLeave() {
      this.isOpen = false;
      this.activeButton = null;
      this.$dispatch("overlay-toggle", false);
    },
    closeMenu() {
      this.isOpen = false;
      this.menu = null;
      this.openIndex = null;
      this.$dispatch("overlay-toggle", false);
    }
  };
}

export default headerMenu;
